import styled from 'styled-components';
import {
    space,
    layout,
    typography,
    color,
    border,
    position,
    SpaceProps,
    LayoutProps,
    TypographyProps,
    ColorProps,
    BorderProps,
    PositionProps,
} from 'styled-system';

type Props = SpaceProps & LayoutProps & TypographyProps & ColorProps & BorderProps & PositionProps;

export const StyledTR = styled.tr<Props>`
    ${space}
    ${layout}
  ${typography}
  ${color}
  ${border}
  ${position}
`;
